export const calculateNextPayment = (startDate, cycle) => {
  // Create dates in local timezone
  const start = new Date(startDate + 'T00:00:00');
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // Create next payment date in local timezone
  let nextPayment = new Date(startDate + 'T00:00:00');

  switch (cycle?.toLowerCase()) {
    case 'weekly':
      // Calculate weeks until next payment
      while (nextPayment <= today) {
        // Use UTC methods to avoid timezone issues
        const newDate = nextPayment.getUTCDate() + 7;
        nextPayment.setUTCDate(newDate);
      }
      break;

    case 'monthly':
      // Keep the same day of month
      const startDay = start.getUTCDate();
      
      while (nextPayment <= today) {
        // Move to next month
        nextPayment.setUTCMonth(nextPayment.getUTCMonth() + 1);
        
        // Handle month end cases
        const lastDayOfMonth = new Date(
          nextPayment.getUTCFullYear(), 
          nextPayment.getUTCMonth() + 1, 
          0
        ).getUTCDate();
        
        nextPayment.setUTCDate(Math.min(startDay, lastDayOfMonth));
      }
      break;

    case 'yearly':
      while (nextPayment <= today) {
        nextPayment.setUTCFullYear(nextPayment.getUTCFullYear() + 1);
      }
      break;

    default:
      // Default to monthly
      while (nextPayment <= today) {
        nextPayment.setUTCMonth(nextPayment.getUTCMonth() + 1);
      }
  }

  // Return date in YYYY-MM-DD format using UTC date
  return `${nextPayment.getUTCFullYear()}-${String(nextPayment.getUTCMonth() + 1).padStart(2, '0')}-${String(nextPayment.getUTCDate()).padStart(2, '0')}`;
}; 